var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup26700(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_26700",
    "data-name": "Group 26700",
    transform: "translate(-1160 -788)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_237",
    "data-name": "Ellipse 237",
    cx: 36,
    cy: 36,
    r: 36,
    transform: "translate(1160 788)",
    fill: "#1859bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23262",
    "data-name": "Path 23262",
    d: "M1018.421,103.775a2.3,2.3,0,0,1-2.228.257,15.845,15.845,0,0,1-9.343-13.345,2.284,2.284,0,0,1,1-2.008l19.309-13.52L1024.9,87.991l12.831,2.264Zm34.573-32.4-10.56,7.467a2.35,2.35,0,0,0-.579,3.269l1.8,2.564a1.173,1.173,0,0,1-.285,1.634L1041.8,87.4l-12.831-2.264,2.264-12.832,1.561-1.092a1.174,1.174,0,0,1,1.634.286l1.6,2.293a2.35,2.35,0,0,0,3.268.58l10.552-7.365a1.769,1.769,0,0,1,2.456.432l1.113,1.48a1.768,1.768,0,0,1-.432,2.455m-3.942,26.975a5.862,5.862,0,1,1-5.862-5.862,5.861,5.861,0,0,1,5.862,5.862",
    transform: "translate(166.156 738.306)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup26700);
export default __webpack_public_path__ + "static/media/Group 26700.f4103ee64773ccb4ae65548e85ce71a2.svg";
export { ForwardRef as ReactComponent };